export default class digiCert {
    constructor() {
        
        return {

            loadCertificate(){
                let exist = document.getElementById('digi-seal');
                if(exist){
                    exist.remove();
                }
                let cid = document.createElement('script');
                cid.async = true;
                cid.id = 'digi-seal';
                cid.src = '//seal.digicert.com/seals/cascade/seal.min.js';
                let s = document.getElementsByTagName('script');
                let ls = s[(s.length - 1)];
                ls.parentNode.insertBefore(cid, ls.nextSibling);
            }
        }
    }    
}


/** WEBPACK FOOTER **
 ** ./src/app/services/digiCert.js
 **/